/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type loginOkta_viewer$ref = any;
export type loginOkta_QueryVariables = {||};
export type loginOkta_QueryResponse = {|
  +viewer: ?{|
    +component: ?string,
    +$fragmentRefs: loginOkta_viewer$ref,
  |}
|};
export type loginOkta_Query = {|
  variables: loginOkta_QueryVariables,
  response: loginOkta_QueryResponse,
|};
*/


/*
query loginOkta_Query {
  viewer {
    component(name: "login_okta")
    ...loginOkta_viewer
    id
  }
}

fragment loginOkta_viewer on Viewer {
  id
  actualPersonId
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "login_okta"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"login_okta\")"
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "loginOkta_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "loginOkta_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "loginOkta_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "loginOkta_Query",
    "operationKind": "query",
    "text": "query loginOkta_Query {\n  viewer {\n    component(name: \"login_okta\")\n    ...loginOkta_viewer\n    id\n  }\n}\n\nfragment loginOkta_viewer on Viewer {\n  id\n  actualPersonId\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7cdea255bfab20d1fb5abbdff8c8dea7';

module.exports = node;
